export { default } from './Progressbar';


// WEBPACK FOOTER //
// ./src/partials/shared/Progressbar/index.js